export default "__VITE_ASSET__CHwNLPrF__"